// src/components/FilterSideBar.tsx
import React, { useState } from 'react';
import '../styles/FilterSideBar.css';

export interface Filters {
  category: string[];
  color: string[];
  size: string[];
}

interface FilterSidebarProps {
  filters: Filters;
  onFilterChange: (filterType: keyof Filters, value: string) => void;
  onResetFilters: () => void;
}

const CATEGORY_OPTIONS = [
  { label: 'T-Shirts', value: 't-shirts' },
  { label: 'Pants', value: 'pants' },
  { label: 'Outerwear', value: 'outerwear' },
  { label: 'Shoes', value: 'shoes' },
  { label: 'Accessories', value: 'accessories' },
];

const COLOR_OPTIONS = [
  { label: 'Black', value: 'black' },
  { label: 'White', value: 'white' },
  { label: 'Navy', value: 'navy' },
  { label: 'Olive', value: 'olive' },
  { label: 'Gray', value: 'gray' },
];

const SIZE_OPTIONS = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

const FilterSidebar: React.FC<FilterSidebarProps> = ({
  filters,
  onFilterChange,
  onResetFilters,
}) => {
  const [isCategoryOpen, setIsCategoryOpen] = useState(true);
  const [isColorOpen, setIsColorOpen] = useState(true);
  const [isSizeOpen, setIsSizeOpen] = useState(false);

  return (
    <div className="sidebar">
      <div className="card">
        {/* Category */}
        <h2 onClick={() => setIsCategoryOpen((prev) => !prev)}>
          {isCategoryOpen ? '–' : '+'} Category
        </h2>
        {isCategoryOpen && (
          <div className="filter-section">
            {CATEGORY_OPTIONS.map(({ label, value }) => (
              <div key={value}>
                <input
                  type="checkbox"
                  id={`category-${value}`}
                  name="category"
                  value={value}
                  checked={filters.category.includes(value)}
                  onChange={(e) => onFilterChange('category', e.target.value)}
                />
                <label htmlFor={`category-${value}`} className="label">
                  {label}
                </label>
              </div>
            ))}
          </div>
        )}

        {/* Color */}
        <h2 onClick={() => setIsColorOpen((prev) => !prev)}>
          {isColorOpen ? '–' : '+'} Color
        </h2>
        {isColorOpen && (
          <div className="filter-section">
            {COLOR_OPTIONS.map(({ label, value }) => (
              <div key={value}>
                <input
                  type="checkbox"
                  id={`color-${value}`}
                  name="color"
                  value={value}
                  checked={filters.color.includes(value)}
                  onChange={(e) => onFilterChange('color', e.target.value)}
                />
                <label htmlFor={`color-${value}`} className="label">
                  {label}
                </label>
              </div>
            ))}
          </div>
        )}

        {/* Size */}
        <h2 onClick={() => setIsSizeOpen((prev) => !prev)}>
          {isSizeOpen ? '–' : '+'} Size
        </h2>
        {isSizeOpen && (
          <div className="filter-section">
            {SIZE_OPTIONS.map((size) => (
              <div key={size}>
                <input
                  type="checkbox"
                  id={`size-${size.toLowerCase()}`}
                  name="size"
                  value={size}
                  checked={filters.size.includes(size)}
                  onChange={(e) => onFilterChange('size', e.target.value)}
                />
                <label htmlFor={`size-${size.toLowerCase()}`} className="label">
                  {size}
                </label>
              </div>
            ))}
          </div>
        )}

        {/* Reset */}
        <button type="button" className="reset-button" onClick={onResetFilters}>
          Reset Filter
        </button>
      </div>
    </div>
  );
};

export default FilterSidebar;
